export var GLOBAL = {
    nombreMuni: 'Las Condes',//
   // url: 'https://nidx.solnet.cl:3922/api/v1/', // prod
    url: 'https://nidx.solnet.cl:3924/api/v1/', // ssl test
    // url: 'https://lnxaz02.solnet.cl:3924/api/v1/', // ssl test azure
    //url: 'http://localhost:3924/api/v1/', // local

    pdfUrl: 'http://download.localhost:3924/api/v1/download',//este funciona
    region: 'REGIÓN METROPOLITANA',
    filedomSolicitudUrl: 'https://lascondes.filedom.cl/dom_new/', //solicitud certificados
    filedomSeguimientoUrl: 'https://lascondes.filedom.cl/seguimiento_certificados/',//seguimientos certificados
    filedomSeguimientoSol: 'https://lascondes.filedom.cl/seguimiento_solicitudes/',

    seguimientoSolicitudes: 'https://lcssl.smartdom.cl/#/seguimiento_expediente/',
    totemUrl: 'http://padrelascasas.filedom.cl/autoatencion/',
    footer: 'MUNICIPALIDAD DE LAS CONDES - DIRECCION DE OBRAS Av. Apoquindo 3400, Las Condes - Santiago de Chile, Teléfono (56-2) 2950 70 000',
    name: 'MUNICIPALIDAD DE LAS CONDES - DIRECCION DE OBRAS',
    dire: 'Av. Apoquindo 3400, Las Condes - Santiago de Chile',
    phone: 'Teléfono (56-2) 2950 70 000',
    webUrl: 'https://www.lascondes.cl/',
    web: 'www.lascondes.cl',

    generico: false,
    ingresoExpedientes: true,
    certificadoFiledom: false,
    seguimientoCertFiledom: true,
    isTest: true, //testssl o prod las condes, activa las vistas correspondientes en el inicio de los servicios

    showModule: {
        1.1: true,
        1.3: true,
        1.5: true,
        1.7: true,
        1.9: true,

        2.1: true,
        2.3: true,
        2.5: true,
        2.7: true,

        3.1: true,
        3.3: true,
        3.6: true,
        3.8: true,
        3.1010: true,

        4.1: true,
        4.3: true,
        4.5: true,

        5.6: true,
        5.8: true,

        8.1: true,
        8.3: true,
        8.5: true,
        8.7: true,
        8.9: true,
        8.1010: false,
        8.11: true,
        8.13: true,

        12.1: true,
        12.4: true,
        12.6: false,
        12.8: false,

        13.1: true,
        13.3: true,
    },

    forms: {
        1.1: 'Solicitud de Permiso de Obra Menor',
        1.3: 'Solicitud de Recesoción Definitiva de Obra Menor',
        1.5: 'Solicitud de Permiso de Obra Menor de Ampliación de Vivienda Social',
        1.7: 'Solicitud de Recepción Definitiva de Obra Menor de Ampliación de Vivienda Social',
        1.9: 'Solicitud de Regularización de Obra Menor (Permiso y recepción definitiva Edificación Antigua de cualquier destino (construida con anterioridad al 31/07/1959)',

        2.1: 'Solicitud de aprobación de anteproyecto de edificación',
        2.3: 'Solicitud de permiso de edificación',
        2.5: 'Solicitud de modificación de anteproyecto de edificación',
        2.7: 'Solicitud de recepción definitiva de obras de edificación',

        3.1: 'Solicitud de aprobación anteproyecto de loteo',
        3.3: 'Solicitud de aprobación de: subdivisión, fusión, urbanización, loteo, loteo con construcción simultánea',
        3.6: 'Solicitud de modificación de: loteo, urbanización, loteo con construcción simultánea, loteol dfl n°2',
        3.8: 'Solicitud de garantía de obras de urbanización',
        3.1010: 'Solicitud de recepción definitiva de obras de urbanización',

        4.1: 'Solicitud de aprobación división predial con afectación a utilidad pública',
        4.3: 'Solicitud de garantía de obras de urbanización',
        4.5: 'Solicitud de recepción definitiva de obras de urbanización',

        5.6: 'Solicitud de Copropiedad Inmobiliaria',
        5.8: 'Solicitud de autorización de obras preliminares y/o demolición',

        8.1: 'Solicitud Permiso de Reconstrucción',
        8.3: 'Solicitud Recepción Definitiva de Reconstrucción de Edificación',
        8.5: 'Solicitud Permiso de Edificación',
        8.7: 'Solicitud Recepción Definitiva de Edificación',
        8.9: 'Solicitud Permiso de Edificación Vivienda Tipo',
        8.1010: 'Solicitud permiso de edificación de vivienda tipo a consecuencia que la vivienda original fue dañada por una catastrofe ART. 5.1.4.',
        8.11: 'Solicitud Recepción Definitiva de Edificación Vivienda Tipo',
        8.13: 'Solicitud Regularización de Edificaciones dañadas a consecuencia de una catástrofe',

        11.1: 'Solicitud de Permiso de Instalación de Torre Soporte de Antenas y Sistemas Radiantes de Transmisión de Telecomunicaciones.',
        11.3: 'Solicitud de Recepción Definitiva de Torre Soporte de Antenas y Sistemas Radiantes de Transmisión de Telecomunicaciones.',

        12.1: 'Solicitud Título I art. 1° Ley N°20.898. Solicitud de Regularización (Permiso y Recepción definitiva)',
        12.4: 'Solicitud Título I art. 3° Ley N°20.898 Solicitud de Regularización (Permiso y Recepción definitiva)',
        12.6: 'Regularización (permiso y recepción definitiva) destinada a microempresa inofensiva o equipamiento social acogida al titulo II .',
        12.8: 'Regularización (permiso y recepción definitiva) vivienda financiada con subsidios para atender la catastrofe del 27 de febrero del 2010 acogida al titulo III.',

        13.1: 'Solicitud de Permiso de Edificación y/o Recepción Definitiva simultánea Edificaciones destinadas a los fines de Bomberos de Chile - Ley N°21.031',
        13.3: 'Solicitud de Permiso de Edificación y/o Recepción Definitiva Destinada a establecimientos educacionales regidos por el D.F.L. N°2, de 1998, MINEDUC - Ley N°21.051'

    }



}
